//REGISTER
import config from "../config";

export const POST_REGISTER =
  config.traffme.registrationUrlApi + "api/affiliates/registration";

export const POST_FAKE_LOGIN = config.traffme.authUrlApi + "api/auth/login";

//AFFILIATES
export const AFFILIATES = "api/affiliates";

//PERMISSIONS
export const GET_PERMISSIONS =
  config.traffme.PERMISSIONS_API + "api/LayoutVisibilities/roles";

//COLOR SETTINGS
export const UPDATE_COLORS =
  config.traffme.PERMISSIONS_API + "api/ColorSettings/update";

export const RESTORE_COLORS =
  config.traffme.PERMISSIONS_API + "api/ColorSettings/restore";

export const GET_COLOR_SETTINGS =
  config.traffme.PERMISSIONS_API + "api/ColorSettings";

export const GET_AUTH_LOGO =
  config.traffme.authUrlApi + "api/ColorSettings/logo";

export const GET_AUTH__START_PAGE_PICTURE =
  config.traffme.authUrlApi + "api/ColorSettings/startpagepicture";

// RECOVERY PASSWO RD
export const RECOVERY_PASSWORD = "/api/PasswordRecovery";
